import * as React from "react";
import Card from "semantic-ui-react/dist/commonjs/views/Card";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";

import {PricingCardsTranslations} from "i18n/containers/Pricing/PricingCards/typing";
import {PricingCardsTexts} from "i18n/containers/Pricing/PricingCards";
import {useProductPayment} from "hooks/payments/useProductPayment";
import ElearningCheckoutModal from "containers/Pricing/card-plans/card-plans-checkout-modal/ElearningCheckoutModal";
import {ProductKeys} from "containers/Pricing/products";
import BusinessProfileModel from "models/business-profiles/BusinessProfile";
import {useLocales} from "@libs";

const CardPlanForElearnings = () => {
    const {currentShortLocale} = useLocales();
    const pricingCardsTranslations: PricingCardsTranslations = {
        ...PricingCardsTexts[currentShortLocale],
    };
    const {onCheckout, productPriceWithDecimal, isCheckoutLoading} = useProductPayment(ProductKeys.Elearnings);
    const [checkoutOpen, isCheckoutOpen] = React.useState(false);
    const handleOnClose = () => {
        isCheckoutOpen(false);
    };
    const handleOnOpen = () => {
        isCheckoutOpen(true);
    };
    const handleOnPay = (e: any, businessProfile: BusinessProfileModel) => {
        onCheckout(e, businessProfile).then(handleOnClose);
    };

    return (
        <Card
            className={"CardPlans CardPlanForElearnings"}
            fluid
        >
            <Card.Content>
                <Card.Header className={"price"}>
                    <span className={"symbol margin-0_5-right"}>US$</span>
                    {productPriceWithDecimal}
                </Card.Header>
                <Card.Meta>
                    <h4>{pricingCardsTranslations.unlimitedElearningsPerMothPack}</h4>
                </Card.Meta>
            </Card.Content>
            <Card.Content extra>
                <Card.Description>
                    <p>{pricingCardsTranslations.availableForProfiles} </p>
                    <ul className={"padding-0-all"}>
                        <li> - {pricingCardsTranslations.adviser} </li>
                        <li> - {pricingCardsTranslations.companies} </li>
                        <li> - {pricingCardsTranslations.accelerators} </li>
                        <li> - {pricingCardsTranslations.incubators} </li>
                        <li> - {pricingCardsTranslations.businessAngels} </li>
                        <li> - {pricingCardsTranslations.institutions} </li>
                        <li> - {pricingCardsTranslations.universities} </li>
                    </ul>
                </Card.Description>
            </Card.Content>
            <Card.Content extra>
                <a>
                    <Button
                        fluid
                        color={"black"}
                        onClick={handleOnOpen}
                    >
                        {pricingCardsTranslations.chooseProduct}
                    </Button>
                </a>
            </Card.Content>
            {checkoutOpen && (
                <ElearningCheckoutModal
                    modalProps={{
                        open: checkoutOpen,
                    }}
                    loading={isCheckoutLoading}
                    onClose={handleOnClose}
                    onPay={handleOnPay}
                />
            )}
        </Card>
    );
};

export default CardPlanForElearnings;
